import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import React from "react";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { get } from "lodash";

export default function SingleDatePicker({
  control,
  name,
  label,
  errors,
  readOnly = false,
  minDate,
  maxDate,
  helperText,
  disabled = false,
  views,
  openTo,
  format = "DD-MM-YYYY",
}) {
  const errorMessage = get(errors, name, {})?.message;
  const combinedHelperText = [helperText, errorMessage]
    .filter(Boolean)
    .join(" * ");

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <DatePicker
            id={name}
            label={label}
            format={format}
            views={views}
            openTo={openTo}
            renderInput={(params) => <TextField {...field} fullWidth />}
            onChange={(date) => field.onChange(date)}
            value={field.value}
            readOnly={readOnly}
            minDate={minDate}
            maxDate={maxDate}
            slotProps={{
              textField: {
                fullWidth: true,
                error: !!errorMessage,
                helperText: combinedHelperText,
                disabled: disabled,
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
}
